export default __webpack_public_path__ + "static/media/triFoldHero.52608028.jpg";